import { render, staticRenderFns } from "./SpeedComparisonChart.vue?vue&type=template&id=6f8fe192&scoped=true&"
import script from "./SpeedComparisonChart.vue?vue&type=script&lang=ts&"
export * from "./SpeedComparisonChart.vue?vue&type=script&lang=ts&"
import style0 from "./SpeedComparisonChart.vue?vue&type=style&index=0&id=6f8fe192&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f8fe192",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VIcon,VProgressLinear,VTooltip})
